import { useAuthStore } from "@";

// Hook for getting user permissions
// Falls back to auth store permissions while React Query data loads
export const useUserPermissions = () => {
  const userPermissions = useAuthStore((state) => state.user?.userPermissions);
  // const { data: permissions, isLoading, isError } = useUserPermissionsQuery();

  return {
    permissions: userPermissions ?? {},
    isLoading: false,
    isError: false,
  };
};
